export default function accessibleMenu() {
	const navItems = Array.from(document.querySelectorAll('.main-menu li'));
	const subMenuLinks = Array.from(document.querySelectorAll('.sub-menu li a'));

	// Accessibilité de base : tabindex et classes
	subMenuLinks.forEach((link) => {
		link.setAttribute('tabindex', -1);
		link.parentElement.classList.add('sub-menu-item');
	});

	navItems.forEach((navItem) => {
		const trigger = navItem.children[0];
		const submenu = navItem.children[1];

		if (!navItem.classList.contains('menu-item-has-children') || !submenu)
			return;

		// Définir les attributs ARIA
		trigger.setAttribute('aria-haspopup', 'true');
		trigger.setAttribute('aria-expanded', 'false');
		trigger.setAttribute('role', 'button');

		function closeAllSubmenus() {
			document.querySelectorAll('.submenu-expanded').forEach((expanded) => {
				expanded.classList.remove('submenu-expanded');
				expanded.previousElementSibling?.setAttribute('aria-expanded', 'false');
				expanded
					.querySelectorAll('a')
					.forEach((link) => link.setAttribute('tabindex', -1));
			});
		}

		function toggleSubMenu() {
			const isOpen = submenu.classList.contains('submenu-expanded');

			closeAllSubmenus();

			if (!isOpen) {
				navItem.classList.add('submenu-expanded');
				submenu.classList.add('submenu-expanded');
				submenu
					.querySelectorAll('a')
					.forEach((link) => link.setAttribute('tabindex', 0));
				trigger.setAttribute('aria-expanded', 'true');
			} else {
				navItem.classList.remove('submenu-expanded');
				submenu.classList.remove('submenu-expanded');
				submenu
					.querySelectorAll('a')
					.forEach((link) => link.setAttribute('tabindex', -1));
				trigger.setAttribute('aria-expanded', 'false');
			}
		}

		// Click
		navItem.addEventListener('click', (e) => {
			// Ne pas interférer avec les clics sur les liens des sous-menus
			if (
				navItem.classList.contains('menu-item-has-children') &&
				e.target === trigger
			) {
				e.preventDefault();
				toggleSubMenu();
			}
		});

		// Clavier : Entrée ou Espace
		navItem.addEventListener('keypress', (e) => {
			if (e.key === ' ' || e.key === 'Enter') {
				if (
					navItem.classList.contains('menu-item-has-children') &&
					e.target === trigger
				) {
					e.preventDefault();
					toggleSubMenu();
				}
			}
		});
	});
}
